import withMetadataArgument from './withMetadataArgument.js'
import { searchNumbers as _searchNumbers } from '../../core/index.js'

export function searchNumbers() {
	return withMetadataArgument(_searchNumbers, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/searchNumbers.js
// module id = 1163
// module chunks = 22